// libraries
import React from 'react'
import clsx from 'clsx'

// icons
import { Download } from '/react4xp/components/Svg/Ux/Ux'
import { PadLock } from '/react4xp/components/Svg/Others/Icons'

export interface MacroDownloadButtonProps {
	theme: 'light' | 'dark'
	text: string
	link: string
	isRestricted?: boolean
}

export default function MacroDownloadButton({
	theme,
	text,
	link,
	isRestricted
}: MacroDownloadButtonProps) {
	return (
		<a
			href={link}
			download={!isRestricted}
			className={clsx(
				'macro__button',
				theme === 'light' && 'macro__button--light'
			)}
		>
			
			<span>
				{text}
			</span>

			{isRestricted ? (
				<PadLock />
			) : (
				<Download />
			)}

		</a>
	)
}